const Endpoint = {
    INFO: "http://localhost:8080/",
    LOGIN: "http://localhost:8080/api/v1/login",
    REGISTER: "http://localhost:8080/api/v1/register"
}

export default Endpoint;
